module.exports = __webpack_public_path__ + "media/images/theme/default/logo-large-43963304f66e43b18a30c8df806a3f11.png";